import React, { Fragment } from 'react'
import Button from './../../../../modules/Button'

const LoginLink = ({ seed, children }) => <a
  href={`https://github.com/login/oauth/authorize?
    client_id=1cfb745895b46acc415f
    &redirect_uri=${encodeURIComponent(getCurrentUrlWithoutQueryString())}
    &scope=${encodeURIComponent('read:org repo')}
  `.replace(/\s+/g, '')}
  // state=${seed} TODO
>
  {children}
</a>

const Login = ({ classes }) => <Fragment>
  <h2>Welcome</h2>
  <br /><br /><br />
  <LoginLink>
    <Button>
      Login
    </Button>
  </LoginLink>
</Fragment>

export default Login

/**
 * Get a random number
 * @returns {number}
 */
function getRandomNumber(){
  var array = new Uint32Array(1)
  return crypto.getRandomValues()[0]
}

/**
 * Gets the current url using the window object without the query string
 * @returns {string}
 */
function getCurrentUrlWithoutQueryString(){
  var queryStart = window.location.href.indexOf('?')
  if (queryStart == -1)
    return window.location.href
  return window.location.href.slice(0, queryStart)
}


// WEBPACK FOOTER //
// ./src/pages/Login/LoginContinue/Login/Login.js